// extracted by mini-css-extract-plugin
export default {"container":"Dcontent_container__VawdP","content":"Dcontent_content__ngeaH","content_inner":"Dcontent_content_inner__Y1wzY"};